// apps/web/src/features/admin/form-config/recognition/ConfidenceHistogram.tsx

interface Bucket {
  min: number;
  max: number;
  count: number;
}

interface ConfidenceHistogramProps {
  buckets: Bucket[];
}

export function ConfidenceHistogram({ buckets }: ConfidenceHistogramProps) {
  if (buckets.length === 0) return null;

  const maxCount = Math.max(...buckets.map((b) => b.count), 1);

  return (
    <div className="confidence-histogram">
      <h4>CONFIDENCE DISTRIBUTION</h4>
      <svg width="100%" height={buckets.length * 32 + 8} role="img" aria-label="Confidence distribution histogram">
        {buckets.map((bucket, i) => {
          const barWidth = (bucket.count / maxCount) * 100;
          const y = i * 32 + 4;
          return (
            <g key={i}>
              <text x={0} y={y + 16} fontSize={12} fill="currentColor">
                {bucket.min.toFixed(1)}&ndash;{bucket.max.toFixed(1)}
              </text>
              <rect
                x={80}
                y={y}
                width={`${barWidth}%`}
                height={20}
                fill="var(--color-accent, #ea580c)"
                rx={2}
              />
              <text x={`calc(80px + ${barWidth}% + 4px)`} y={y + 16} fontSize={12} fill="currentColor">
                {bucket.count}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
}
